module.exports = __webpack_public_path__ + "media/images/logo_goo-ee4dc98b16c45ff71b42c69a29931ec2.png";